













































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import columns from "./inventory-columns";
import opsColumns from "./ops-inventory-columns";
import clientColumns from "./client-inventory-columns";
import ReportDetail from "@/views/operation/inventory/inventoryReportDetail.vue";
import _ from "lodash";
import InventoryReportDetailInput from "@/store/entities/inventoryReportDetailInput";

class PageAdminInventoryReportRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  warehouseCode: string;
  type: number;
  conditionTypeCode: string;
  assetTypeCode: string;
  inventoryQty: number = 0;
  pageSize: number = 0;
  pageNumber: number = 0;
  categoryId: number = 0;
  brandId: number = 0;
  poProductType: string = AppConsts.allItemValue;
}
@Component({
  components: { "inventoryReport-detail": ReportDetail },
})
export default class AdminInventoryReport extends AbpBase {
  //filters
  pagerequest: PageAdminInventoryReportRequest =
    new PageAdminInventoryReportRequest();
  clients = [];
  warehouses = [];
  conditionTypes = [];
  assetTypes = [];
  categoriesOfClient: [] = [];
  brands: [] = [];
  productTypes = [];
  spinShow: boolean = false;
  get sumOnHand() {
    if (this.totalCount > 0) {
      var totalInfo =
        this.$store.state.inventoryReport.inventoryStatisticsTotalInfo;
      if (!_.isNil(totalInfo)) return _.get(totalInfo, "onHand");
    }
    return 0;
  }
  get sumAvailable() {
    if (this.totalCount > 0) {
      var totalInfo =
        this.$store.state.inventoryReport.inventoryStatisticsTotalInfo;
      if (!_.isNil(totalInfo)) return _.get(totalInfo, "available");
    }
    return 0;
  }
  get sumWaitingIn_Po() {
    if (this.totalCount > 0) {
      var totalInfo =
        this.$store.state.inventoryReport.inventoryStatisticsTotalInfo;
      if (!_.isNil(totalInfo)) return _.get(totalInfo, "waitingIn_Po");
    }
    return 0;
  }
  get sumWaitingIn_To() {
    if (this.totalCount > 0) {
      var totalInfo =
        this.$store.state.inventoryReport.inventoryStatisticsTotalInfo;
      if (!_.isNil(totalInfo)) return _.get(totalInfo, "waitingIn_To");
    }
    return 0;
  }
  get sumWaitingOut_SoR() {
    if (this.totalCount > 0) {
      var totalInfo =
        this.$store.state.inventoryReport.inventoryStatisticsTotalInfo;
      if (!_.isNil(totalInfo)) return _.get(totalInfo, "waitingOut_SoR");
    }
    return 0;
  }
  get sumWaitingOut_To() {
    if (this.totalCount > 0) {
      var totalInfo =
        this.$store.state.inventoryReport.inventoryStatisticsTotalInfo;
      if (!_.isNil(totalInfo)) return _.get(totalInfo, "waitingOut_To");
    }
    return 0;
  }
  get sumLostQty() {
    if (this.totalCount > 0) {
      var totalInfo =
        this.$store.state.inventoryReport.inventoryStatisticsTotalInfo;
      if (!_.isNil(totalInfo)) return _.get(totalInfo, "lostQty");
    }
    return 0;
  }
  get sumCubicMeters() {
    if (this.totalCount > 0) {
      var totalInfo =
        this.$store.state.inventoryReport.inventoryStatisticsTotalInfo;
      if (!_.isNil(totalInfo)) return _.get(totalInfo, "cubicMeters");
    }
    return 0;
  }
  productSelected: InventoryReportDetailInput =
    new InventoryReportDetailInput();
  viewDetailModelShow: boolean = false;
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  convertValueLessThanZero(value) {
    if (Util.isEmpty(value.toString())) return value;
    var decimalValue = parseFloat(value);
    if (Util.isNull(decimalValue)) {
      return 0;
    }
    decimalValue = decimalValue < 0 ? 0 : decimalValue;
    return decimalValue;
  }
  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(async (result) => {
        var re = this.$store.state.client.clientsForSelect;
        this.$set(
          this.pagerequest,
          "clientCode",
          re.length === 0 ? "" : re[0].code
        );
        this.clients = re;
        await this.changeClientCode();
      });
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
        data: { hasAllItem: true },
      })
      .then((result) => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        this.$set(
          this.pagerequest,
          "warehouseCode",
          re.length === 0 ? "" : re[0].id
        );
        this.warehouses = re;
      });
  }
  async changeClientCode() {
    if (
      Util.isNull(this.pagerequest.clientCode) ||
      Util.isEmpty(this.pagerequest.clientCode)
    )
      return;
    await this.getClientAssetTypes();
    await this.getCategoriesOfClientForSelect();
  }
  async getConditionTypes() {
    await this.$store
      .dispatch({
        type: "masterData/getFeatureConditionTypesForSelect",
        data: {
          featureCode: AppConsts.featureConditionType.Report,
          hasAllItem: true,
        },
      })
      .then((re) => {
        this.conditionTypes = re;
        this.pagerequest.conditionTypeCode =
          this.conditionTypes.length === 0 ? "" : this.conditionTypes[0].id;
      });
  }
  async getClientAssetTypes() {
    await this.$store
      .dispatch({
        type: "client/getClientAssetTypeServices",
        data: this.pagerequest.clientCode,
      })
      .then((result) => {
        var re = this.$store.state.client.clientAssetTypes;
        re.unshift({
          id: AppConsts.allItemValue,
          displayName: this.L(AppConsts.All),
        });
        this.$set(
          this.pagerequest,
          "assetTypeCode",
          re.length === 0 ? "" : re[0].id
        );
        this.assetTypes = re;
      });
  }
  async getCategoriesOfClientForSelect() {
    await this.$store
      .dispatch({
        type: "category/getCategoriesByClientForSelect",
        data: { clientCode: this.pagerequest.clientCode },
      })
      .then(() => {
        var re = this.$store.state.category.categoriesOfClientForSelect;
        re.unshift({ id: -1, name: this.L(AppConsts.All) });
        this.categoriesOfClient = re;
        this.pagerequest.categoryId = -1;
      });
  }
  async getBrands() {
    this.$store
      .dispatch({
        type: "masterData/getBrands",
      })
      .then((result) => {
        var re = result;
        re.unshift({ id: -1, name: this.L(AppConsts.All) });
        this.brands = re;
        this.pagerequest.brandId = -1;
      });
  }
  async getProductTypes() {
    this.$store
      .dispatch({
        type: "purchaseOrder/getListTypeForSelect",
        data: {
          tableName: AppConsts.tableRef.tablePo.name,
          columnName: AppConsts.tableRef.tablePo.column.productType,
          prefix: AppConsts.tableRef.tablePo.prefix.productType,
          hasAllItem: false,
        },
      })
      .then((re) => {
        re.unshift({
          code: AppConsts.allItemValue,
          description: this.L(AppConsts.All),
        });
        this.productTypes = re;
        this.pagerequest.poProductType = AppConsts.allItemValue;
      });
  }
  get list() {
    var re = this.$store.state.inventoryReport.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  get loading() {
    return this.$store.state.inventoryReport.loading;
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: "inventoryReport/export",
      data: this.buildPageRequest(),
    });
  }
  buildPageRequest() {
    var type = AppConsts.inventoryReportType.admin;
    var clientCode = this.pagerequest.clientCode;
    var warehouseCode = this.pagerequest.warehouseCode;
    if (this.isClient()) {
      type = AppConsts.inventoryReportType.client;
      clientCode = this.$store.state.session.client.code;
    }
    if (this.isTenant()) {
      type = AppConsts.inventoryReportType.operation;
      warehouseCode = this.$store.state.session.tenant.tenancyName;
    }
    var data = {
      clientCode: clientCode,
      warehouseCode: warehouseCode,
      keyword: this.pagerequest.keyword,
      type: type,
      assetTypeCode: this.pagerequest.assetTypeCode,
      conditionTypeCode: this.pagerequest.conditionTypeCode,
      inventoryQty: +this.pagerequest.inventoryQty,
      pageSize: this.pagerequest.pageSize,
      pageNumber: this.pagerequest.pageNumber,
      categoryId: this.pagerequest.categoryId,
      brandId: this.pagerequest.brandId,
      poProductType: this.pagerequest.poProductType,
    };
    return data;
  }
  async search() {
    this.$store.commit("inventoryReport/setCurrentPage", 1);
    await this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("inventoryReport/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("inventoryReport/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.pageSize = this.pageSize;
    this.pagerequest.pageNumber = this.currentPage;
    var data = this.buildPageRequest();
    //filters
    await this.$store.dispatch({
      type: "inventoryReport/getAll",
      data: data,
    });
  }
  get pageSize() {
    return this.$store.state.inventoryReport.pageSize;
  }
  get totalCount() {
    return this.$store.state.inventoryReport.totalCount;
  }
  get currentPage() {
    return this.$store.state.inventoryReport.currentPage;
  }
  showDetail(index: number, type: string) {
    var rowItem = this.$store.state.inventoryReport.list[index];
    this.productSelected.sku = rowItem.sku;
    this.productSelected.productName = rowItem.productName;
    this.productSelected.warehouseCode = rowItem.warehouseCode;
    this.productSelected.type = type;
    this.productSelected.productId = rowItem.productId;
    this.productSelected.assetTypeCode = rowItem.assetTypeCode;
    this.productSelected.assetTypeName = rowItem.assetTypeName;
    this.productSelected.conditionTypeCode = rowItem.conditionTypeCode;
    this.productSelected.conditionTypeName = rowItem.conditionTypeName;
    this.viewDetailModelShow = true;
  }
  renderColumn() {
    if (this.isClient()) {
      return clientColumns.concat(columns);
    }
    if (this.isTenant()) {
      return opsColumns.concat(columns);
    }
    return clientColumns.concat(opsColumns).concat(columns);
  }
  get columns() {
    return [
      {
        title: Util.L("Order"),
        width: 60,
        fixed: "left",
        key: "orderNo",
      },
      {
        title: this.L("SKU"),
        width: 200,
        fixed: "left",
        slot: "objectLink",
      },
      {
        title: this.L("ExternalCode"),
        width: 200,
        fixed: "left",
        key: "externalCode",
      },
      ...this.renderColumn(),
      {
        title: `${Util.L("OnHand")} (${Util.toViewNumberString(
          this.sumOnHand
        )})`,
        width: 100,
        key: "onHand",
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.onHand));
        },
      },
      {
        title: `${Util.L("Available")} (${Util.toViewNumberString(
          this.sumAvailable
        )})`,
        width: 100,
        key: "available",
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.available));
        },
      },
      {
        title: `${Util.L("WaitingIn_Po")} (${Util.toViewNumberString(
          this.sumWaitingIn_Po
        )})`,
        width: 100,
        slot: "waitingIn_Po",
        align: "right",
      },
      {
        title: `${Util.L("WaitingIn_To")} (${Util.toViewNumberString(
          this.sumWaitingIn_To
        )})`,
        width: 100,
        slot: "waitingIn_To",
        align: "right",
      },
      {
        title: `${Util.L("WaitingOut_SoR")} (${Util.toViewNumberString(
          this.sumWaitingOut_SoR
        )})`,
        width: 100,
        slot: "waitingOut_SoR",
        align: "right",
      },
      {
        title: `${Util.L("WaitingOut_To")} (${Util.toViewNumberString(
          this.sumWaitingOut_To
        )})`,
        width: 100,
        slot: "waitingOut_To",
        align: "right",
      },
      {
        title: `${Util.L("LostQty")} (${Util.toViewNumberString(
          this.sumLostQty
        )})`,
        width: 100,
        key: "lostQty",
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.lostQty));
        },
      },
      {
        title: `Tổng thể tích (${ Util.formatLocateNumber(this.sumCubicMeters, 6)}) m3`,
        width: 200,
        key: "cubicMeters",
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.formatLocateNumber(params.row.cubicMeters, 6));
        },
      },
    ];
  }
  async created() {
    this.spinShow = true;
    try {
      await this.getClients();
      await this.getWarehouses();
      await this.getConditionTypes();
      await this.getBrands();
      await this.getProductTypes();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
